<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.2409 3.93604C16.4769 3.93604 19.9569 7.06804 20.5449 11.136H23.0409L18.8409 15.936L14.6409 11.136H17.4249C17.1563 9.96147 16.4974 8.91264 15.5559 8.16074C14.6144 7.40884 13.4458 6.99827 12.2409 6.99604C10.5009 6.99604 8.96494 7.84804 7.99294 9.13204L5.94094 6.79204C6.7266 5.89421 7.69526 5.17485 8.78186 4.68226C9.86847 4.18966 11.0479 3.93523 12.2409 3.93604ZM11.7609 20.064C7.53694 20.064 4.04494 16.932 3.45694 12.864H0.960938L5.16094 8.06404C6.56494 9.66004 7.95694 11.268 9.36094 12.864H6.57694C6.8456 14.0386 7.50445 15.0874 8.44596 15.8393C9.38747 16.5912 10.556 17.0018 11.7609 17.004C13.5009 17.004 15.0369 16.152 16.0089 14.868L18.0609 17.208C17.2763 18.1071 16.3078 18.8273 15.221 19.32C14.1342 19.8127 12.9542 20.0664 11.7609 20.064Z"
        fill="#9B237B"
      />
    </svg>
  </div>
</template>
